let EVENT_HANDLERS = new Map();
let UNIQUE_KEYS = new Set();
import logClientChatter from 'rlink-debug-utils/logClientChatter';

export default function onRlinkEvent (eventFilter, eventHandler, uniqueKey = null) {
  eventHandler.detachFromRlink = () => {
    EVENT_HANDLERS.delete(eventFilter);
    if (uniqueKey !== null) {
      UNIQUE_KEYS.delete(uniqueKey);
    }
  };
  if (uniqueKey === null || !UNIQUE_KEYS.has(uniqueKey)) {
    EVENT_HANDLERS.set(eventFilter, eventHandler);
    if (uniqueKey !== null) {
      UNIQUE_KEYS.add(uniqueKey);
    }
  }
  return eventHandler;

}


if (typeof window !== 'undefined') {

  window.rlinkCallback = obj => {
    logClientChatter('[INCOMING RLINK EVENT]', obj);
    for (let [filter, handler] of EVENT_HANDLERS) {
      let matchesFilter = true;
      for (let key in filter) {
        if (!(key in obj)
            || (typeof filter[key] === 'function'
                ? !filter[key](obj[key])
                : filter[key] !== obj[key])) {
          matchesFilter = false;
          break;
        }
      }
      if (matchesFilter) {
        handler(obj);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-reliclink/onRlinkEvent.js